import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ControlStockProveedores from './ControlStock/ControlStockProveedores';

export default class AdmProveedores extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="ControlStock" element={<ControlStockProveedores />} />
                    <Route path="" element={<ControlStockProveedores />} />
                </Routes>
            </div>
        );
    }
}
